/** Where a conversation (or one of its messages and threads) lives in the app (PLAN §6.5):
 *  channels at /ch/<slug>, everything else at /c/<id>; `?thread=` opens the thread panel,
 *  `?m=` jumps to a message. */
export type Place = {
  kind?: string | null;
  slug?: string | null;
  id: string;
};

export function placeHref(
  place: Place,
  opts: { thread?: string | null; message?: string | null } = {},
) {
  const base =
    place.kind === "channel" && place.slug
      ? `/ch/${encodeURIComponent(place.slug)}`
      : `/c/${place.id}`;
  const q = new URLSearchParams();
  if (opts.thread) q.set("thread", opts.thread);
  if (opts.message) q.set("m", opts.message);
  const s = q.toString();
  return s ? `${base}?${s}` : base;
}

// The app's own pages (not /api/ downloads or sign-in links, which leave the app on purpose).
const APP_PAGE = /^\/(?:(?:c|ch)\/[^/?#]+|inbox|automations|admin(?:\/[^?#]*)?|me)?(?:[?#].*)?$/;

/** A link to one of the app's own pages, as an in-app path (R10-N5: a pasted Copy link or a
 *  citation opens here, not in a new tab or Safari); null for anything else. */
export function inAppPath(href: string | null | undefined): string | null {
  if (!href || typeof window === "undefined") return null;
  let url: URL;
  try {
    url = new URL(href, window.location.origin);
  } catch {
    return null;
  }
  if (url.origin !== window.location.origin) return null;
  const path = url.pathname + url.search + url.hash;
  return APP_PAGE.test(path) ? path : null;
}

/** An absolute link to share (Copy link). */
export function absolute(href: string): string {
  return typeof window === "undefined" ? href : `${window.location.origin}${href}`;
}
